import { jsx as e } from "react/jsx-runtime";
import { useContext as r, useState as t, useRef as n, useCallback as u, useEffect as c, useMemo as i, createContext as o, useId as s } from "react";
import l from "../../node_modules/lodash-es/get.js";
import f from "../../node_modules/lodash-es/isEqual.js";
const a = () => {
}, d = () => a, m = { registerEntry: d, focusField: () => false, focusFirstError: () => false, focusFirstField: a, focusNextFrom: a, enableValidateOnNavigate: false, validateField: a, setFieldTouched: a, errorsRef: { current: {} }, orderRef: { current: [] }, registryRef: { current: /* @__PURE__ */ new Map() }, submitButtonRef: { current: null }, createElementRef: () => a, submitFallbackButtonName: void 0 }, g = o(m), F = (e2) => !!e2 && (!!document.contains(e2) && (!e2.hasAttribute("disabled") && ("true" !== e2.getAttribute("aria-disabled") && 0 !== e2.getClientRects().length))), v = ({ children: r2, enableFocusOnError: o2 = true, enableValidateOnNavigate: s2 = true, enableFocusFirstOnSubmitSuccess: a2 = true, autoFocusOnFirst: d2 = false, resetAutofocusOnValueChange: m2, values: v2, isLoading: b2 = false, errors: y2, submitCount: h2, validateField: p2, setFieldTouched: k2, initialValues: E2, submitFallbackButtonName: R2 }) => {
  const [N2, O] = t(false), x = n(/* @__PURE__ */ new Map()), T = n([]), I = n(null), A = n(null), B = n(), q = n(null), L = n(y2), M = n(false), w = n(m2), C = n(/* @__PURE__ */ new Map()), D = () => {
    const e2 = Array.from(x.current.entries()).sort(([, e3], [, r3]) => {
      const t2 = e3.ref.current, n2 = r3.ref.current;
      if (!t2 || !n2 || t2 === n2) return 0;
      if (t2.contains(n2)) return -1;
      const u2 = t2 == null ? void 0 : t2.compareDocumentPosition(n2);
      return u2 & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : u2 & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
    T.current = e2.map(([e3]) => e3);
  }, P = u(() => {
    var _a, _b;
    const e2 = T.current.find((e3) => {
      const r4 = x.current.get(e3);
      return "field" === (r4 == null ? void 0 : r4.kind);
    }), r3 = e2 && ((_a = x.current.get(e2)) == null ? void 0 : _a.ref.current) || null;
    if (F(r3)) {
      if (r3.focus(), r3 instanceof HTMLInputElement || r3 instanceof HTMLTextAreaElement) {
        const t2 = v2 ? l(v2, e2) : r3 == null ? void 0 : r3.value, n2 = null != t2 ? (_b = String(t2)) == null ? void 0 : _b.length : 0;
        try {
          r3.setSelectionRange(n2, n2);
        } catch {
        }
      }
      return true;
    }
    return false;
  }, [v2]), S = u((e2, r3, t2, n2) => {
    if (T.current.includes(e2) || T.current.push(e2), x.current.set(e2, { ref: r3, kind: t2, required: n2 }), O(true), D(), "field" === t2) {
      const e3 = document.activeElement, t3 = r3.current, n3 = Array.from(x.current.values()).some((r4) => {
        const t4 = r4.ref.current;
        return t4 && e3 && (t4 === e3 || t4.contains(e3));
      });
      (!e3 || e3 === document.body || !n3 && e3) && F(t3) && t3.focus();
    }
    return () => {
      x.current.delete(e2), T.current = T.current.filter((r4) => r4 !== e2), D();
    };
  }, []), V = u((e2) => {
    var _a;
    const r3 = x.current.get(e2), t2 = (_a = r3 == null ? void 0 : r3.ref) == null ? void 0 : _a.current;
    return !!t2 && (t2.focus(), "select" in t2 && "function" == typeof t2.select && t2.select(), true);
  }, []), _ = u((e2) => {
    if (!e2) return false;
    for (const r3 of T.current) if (l(e2, r3) && V(r3)) return true;
    return false;
  }, [V]), j = u((e2) => (r3) => {
    if (!e2) return;
    const t2 = C.current.get(e2);
    if (!r3) return t2 == null ? void 0 : t2(), void C.current.delete(e2);
    t2 == null ? void 0 : t2();
    const n2 = S(e2, { current: r3 }, "element", false);
    C.current.set(e2, n2);
  }, [S]), G = u(() => {
    const e2 = T.current.find((e3) => {
      const r3 = x.current.get(e3);
      return "field" === (r3 == null ? void 0 : r3.kind);
    });
    e2 && V(e2);
  }, [V]), H = u((e2, r3 = "next") => {
    const t2 = T.current.map((e3) => {
      var _a;
      return (_a = x.current.get(e3)) == null ? void 0 : _a.ref.current;
    }).filter((e3) => Boolean(e3));
    if (!t2.length) return;
    const n2 = T.current.indexOf(e2);
    if (n2 < 0) return;
    const u2 = t2[n2 + ("prev" === r3 ? -1 : 1)] || null, c2 = q.current || null, i2 = "next" === r3 && n2 === T.current.length - 1 ? c2 : u2 || c2;
    i2 == null ? void 0 : i2.focus();
  }, []);
  c(() => {
    L.current = y2;
  }, [y2]), c(() => {
    void 0 !== m2 && w.current !== m2 && (w.current = m2, M.current = false);
  }, [m2]), c(() => {
    !d2 || !N2 || b2 || M.current || E2 && v2 && !f(E2, v2) || !P() || (M.current = true);
  }, [d2, P, N2, b2, E2, v2, m2]), c(() => {
    if (o2 && 0 !== h2 && !(null !== I.current && h2 <= I.current) && y2 && 0 !== Object.keys(y2).length) return I.current = h2, B.current = requestAnimationFrame(() => {
      _(y2);
    }), () => {
      B.current && cancelAnimationFrame(B.current);
    };
  }, [o2, y2, _, h2]), c(() => {
    const e2 = A.current;
    if (!a2 || 0 === h2 || null !== e2 && h2 <= e2) return;
    A.current = h2;
    return T.current.some((e3) => {
      const r3 = x.current.get(e3);
      return "field" === (r3 == null ? void 0 : r3.kind) && l(y2, e3);
    }) ? void 0 : (B.current = requestAnimationFrame(() => {
      G();
    }), () => {
      B.current && cancelAnimationFrame(B.current);
    });
  }, [a2, y2, G, h2]);
  const K = i(() => ({ registerEntry: S, focusField: V, focusFirstError: _, focusFirstField: G, focusNextFrom: H, enableValidateOnNavigate: s2, validateField: p2, setFieldTouched: k2, errorsRef: L, orderRef: T, registryRef: x, submitButtonRef: q, createElementRef: j, submitFallbackButtonName: R2 }), [V, _, G, H, S, s2, p2, k2, j, R2]);
  return e(g.Provider, { value: K, children: "function" == typeof r2 ? r2(K) : r2 });
}, b = () => r(g), y = () => {
  const { focusFirstField: e2 } = b();
  return e2;
}, h = (e2, r2, t2, n2) => {
  const { focusNextFrom: c2 } = b();
  return u((u2 = false) => {
    var _a;
    return !(!c2 || !n2 && !u2) && (((e3) => {
      if (!e3) return false;
      const r3 = document.activeElement;
      return !r3 || r3 === document.body || e3 && (r3 === e3 || e3.contains(r3));
    })(r2) && (c2 == null ? void 0 : c2(e2)), (_a = t2.current) == null ? void 0 : _a.call(t2), t2.current = null, true);
  }, [e2, r2, t2, n2, c2]);
}, p = (e2, r2) => {
  const { registerEntry: t2 } = b(), u2 = n(null), i2 = n(null), { kind: o2, skip: s2 = false, required: l2 } = r2 ?? {}, f2 = h(e2, u2.current, i2, s2), a2 = t2 !== d;
  return c(() => {
    if (t2 && a2 && !f2()) return i2.current = t2(e2, u2, o2, l2), () => {
      f2(true);
    };
  }, [e2, t2, f2, o2, l2, a2]), { ref: a2 ? u2 : null };
}, k = (e2, r2) => {
  const { ref: t2 } = p(e2, { kind: "field", required: r2 });
  return { fieldRef: t2 };
}, E = (e2, r2) => {
  const t2 = s(), u2 = n(`${e2}-${t2}`), { ref: c2 } = p(u2.current, { kind: "element", skip: !!(r2 == null ? void 0 : r2.skip) });
  return { elementRef: c2 };
}, R = () => {
  const e2 = n(null), r2 = n(null), t2 = b(), o2 = t2 !== m, { orderRef: s2, registryRef: f2, submitButtonRef: a2, enableValidateOnNavigate: d2, validateField: g2, setFieldTouched: v2, errorsRef: y2, submitFallbackButtonName: h2 } = t2, p2 = u(async (e3, r3) => {
    const t3 = s2.current.map((e4) => {
      var _a;
      return (_a = f2.current.get(e4)) == null ? void 0 : _a.ref.current;
    }).filter((e4) => Boolean(e4));
    if (!t3.length) return;
    if (e3 === a2.current && !r3) return;
    const n2 = e3 === a2.current ? t3.length : t3.findIndex((r4) => r4 === e3 || r4.contains(e3));
    if (n2 < 0) {
      const e4 = r3 ? t3[t3.length - 1] : a2.current;
      return void (e4 == null ? void 0 : e4.focus());
    }
    const u2 = s2.current[n2], c2 = u2 ? f2.current.get(u2) : void 0;
    if (d2 && "field" === (c2 == null ? void 0 : c2.kind) && g2 && v2) {
      v2(u2, true, false), await g2(u2);
      const t4 = y2.current;
      if (!r3 && t4 && l(t4, u2)) return void e3.focus();
    }
    const i2 = r3 ? -1 : 1;
    let o3 = n2 + i2, m2 = null;
    for (; o3 >= 0 && o3 < t3.length; ) {
      const e4 = t3[o3];
      if (F(e4)) {
        m2 = e4;
        break;
      }
      o3 += i2;
    }
    const b2 = a2.current || null;
    if (!m2 && !b2) return;
    const h3 = (r3 || n2 !== t3.length - 1) && m2 || b2;
    h3 == null ? void 0 : h3.focus(), m2 && "select" in m2 && "function" == typeof m2.select && m2.select();
  }, [d2, v2, g2, a2, y2, s2, f2]), k2 = u((e3) => {
    var _a, _b, _c;
    const r3 = e3.target, t3 = "Enter" === e3.key;
    if ((t3 || "Tab" === e3.key) && r3) {
      if (t3) {
        const t4 = h2 && !F(a2.current) ? (_b = (_a = f2.current.get(h2)) == null ? void 0 : _a.ref) == null ? void 0 : _b.current : a2.current, n2 = s2.current.map((e4) => ({ name: e4, entry: f2.current.get(e4) })).filter((e4) => {
          var _a2, _b2;
          return (_b2 = (_a2 = e4.entry) == null ? void 0 : _a2.ref) == null ? void 0 : _b2.current;
        }), u2 = [...n2].reverse().findIndex((e4) => {
          var _a2, _b2;
          return "field" === ((_a2 = e4.entry) == null ? void 0 : _a2.kind) && true === ((_b2 = e4.entry) == null ? void 0 : _b2.required);
        }), c2 = [...n2].reverse().findIndex((e4) => {
          var _a2;
          return "field" === ((_a2 = e4.entry) == null ? void 0 : _a2.kind);
        });
        if (-1 === c2) return;
        const i2 = n2.length - 1 - c2, o3 = -1 === u2 ? i2 : n2.length - 1 - u2, m2 = n2.findIndex((e4) => {
          var _a2, _b2;
          return ((_b2 = (_a2 = e4.entry) == null ? void 0 : _a2.ref) == null ? void 0 : _b2.current) === r3;
        });
        if (m2 !== i2 && m2 !== o3) return;
        if (!d2 || !g2 || !v2) return void (t4 == null ? void 0 : t4.focus());
        const b2 = (_c = n2[m2]) == null ? void 0 : _c.name;
        if (!b2) return;
        return e3.preventDefault(), v2(b2, true, false), void Promise.resolve(g2(b2)).then(() => {
          const e4 = y2.current;
          e4 && l(e4, b2) ? r3.focus() : t4 == null ? void 0 : t4.focus();
        });
      }
      (a2.current !== r3 || e3.shiftKey) && (e3.preventDefault(), p2(r3, e3.shiftKey));
    }
  }, [h2, d2, p2, v2, g2, y2, s2, f2, a2]);
  return c(() => {
    e2.current = k2;
  }, [k2]), i(() => o2 ? { ref: (t3) => {
    var _a;
    (_a = r2.current) == null ? void 0 : _a.call(r2), r2.current = null, t3 && (t3.addEventListener("keydown", e2.current), r2.current = () => t3.removeEventListener("keydown", e2.current));
  } } : { ref: null }, [o2]);
}, N = () => {
  const e2 = b(), r2 = e2 !== m, { submitButtonRef: t2 } = e2;
  return i(() => ({ ref: r2 ? t2 : null }), [r2, t2]);
};
export {
  v as FormElementRegistryProvider,
  b as useFormElementRegistry,
  E as useRegisterFormNavigationElement,
  k as useRegisterFormNavigationField,
  R as useRegisterFormRootContainer,
  N as useRegisterSubmitButton,
  y as useResetFormFocus
};
//# sourceMappingURL=useFormElementRegistry.js.map
